"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const formatUpperCase = (value) => {
    return value && typeof value === 'string' ? value.toUpperCase() : '';
};
exports.default = formatUpperCase;
